module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-up-left-circle-fill-9a313593.svg";